var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArroww(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99901 12.0041L12.6367 5.0317L10.0146 14.9184C9.97318 15.0773 10.1471 15.2078 10.2816 15.1196L11.8907 14.065C11.9616 14.0185 12.0116 13.9481 12.0335 13.8666L14.8648 3.20053C14.8908 3.1029 14.8956 3.00011 14.8788 2.89913C14.8621 2.79815 14.8242 2.70134 14.7678 2.61525C14.7114 2.52916 14.6377 2.45581 14.5518 2.40017C14.4659 2.34453 14.3697 2.3079 14.2698 2.29276L3.29527 0.621924C3.25198 0.615365 3.21063 0.62366 3.17609 0.646301L1.51252 1.73667C1.37798 1.82485 1.4295 2.03828 1.59044 2.06176L11.7005 3.60331L1.06279 10.5757C0.982791 10.6281 0.961687 10.7387 1.01589 10.8214L1.75501 11.9491C1.80921 12.0318 1.91901 12.0565 1.99901 12.0041Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArroww);
export default __webpack_public_path__ + "static/media/arroww.d4a9d0c88f09222fdaf33a76a11b7755.svg";
export { ForwardRef as ReactComponent };